import Notify from "./Notify";
import { getFcmToken } from "./Notify";

export { getFcmToken };
export default Notify;
